module.exports = __webpack_public_path__ + "img/soup.54d1ee6e.svg";